<template>
  <div class="room remote-history" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command"></div>
    <el-table
      :data="tableData"
      style="width: 100%"
      :span-method="tableSpanMethod"
      :max-height="tableMaxHeight"
    >
      <el-table-column align="center" label="序号" prop="index" width="100"></el-table-column>
      <el-table-column align="center" label="任务编号" prop="clientMissionId"></el-table-column>
      <el-table-column align="center" label="桥梁" prop="bridgeName"></el-table-column>
      <el-table-column align="center" label="设备" prop="deviceName"></el-table-column>
      <el-table-column align="center" label="创建时间" prop="createdDate"></el-table-column>
      <el-table-column align="center" label="任务状态" prop="status">
        <template slot-scope="scope">
          <el-tooltip
            :disabled="scope.row.tooltip === ''"
            :content="scope.row.tooltip"
            placement="right"
          >
            <el-tag class="status-tag" :type="scope.row.statusType">{{scope.row.status}}</el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建用户" prop="createUserName"></el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
    <FullScreenDialog ref="tempDialog" :message="'远程遥控模块整体升级, 遥控功能暂停使用.'"></FullScreenDialog>
  </div>
</template>
<script>
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: 'RemoteHistory',
  data() {
    return {
      timer: null,
      tableData: [],
      loading: false,
      shownewUser: false,
      checkUserId: '',
      totalCount: 1,
      currentPage: 1,
      pageSize: 6,
      bridgeId: 'ca6d55dc-e059-4d72-b494-e3140e31b2fe',
      bridgeTranslateDict: {},
      deviceTranslateDict: {},
      deviceNameReplaceList: ['状态', '(枚举)'],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
    };
  },
  computed: {
    tableSpanRowIndexDict() {
      let clientMissionIdRowIndexListDict = {};
      for (let i = 0; i < this.tableData.length; i++) {
        const mission = this.tableData[i];
        if (
          clientMissionIdRowIndexListDict[mission.clientMissionId] === undefined
        ) {
          clientMissionIdRowIndexListDict[mission.clientMissionId] = [i];
        } else {
          clientMissionIdRowIndexListDict[mission.clientMissionId].push(i);
        }
      }

      let result = {};
      for (let clientMissionId in clientMissionIdRowIndexListDict) {
        let rowList = clientMissionIdRowIndexListDict[clientMissionId];
        result[Math.min.apply(null, rowList)] = rowList.length;
      }

      return result;
    },
  },
  mounted() {
    this.$refs["tempDialog"].show();
    return;

    this.loading = true;
    this.getDataCount();
    this.getDataList();

    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left:
        (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 +
        'px',
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight =
        this.$refs.room.offsetHeight - this.paginationHeight;
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left:
            (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) /
              2 +
            'px',
        };
      });
    },
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (column.label === '序号' || column.label === '任务编号') {
        return {
          rowspan: this.tableSpanRowIndexDict[rowIndex],
          colspan: 1,
        };
      }
    },
    refreshData() {
      this.loading = true;
      this.getDataList();
    },
    currentChange(index) {
      this.loading = true;
      this.currentPage = index;
      this.getDataList();
    },
    getDataCount() {
      return;

      this.$http
        .get(
          '/remoteControl/RemoteMissionByBridgeCount?bridgeId=' + this.bridgeId
        )
        .then((res) => {
          this.totalCount = res.data.count;
        });
    },
    getDataList() {
      return;

      this.$http
        .get(
          '/remoteControl/RemoteMissionByBridge?bridgeId=' +
            this.bridgeId +
            '&start=' +
            (this.currentPage - 1) * this.pageSize +
            '&limit=' +
            this.pageSize
        )
        .then((res) => {
          let dataList = res.data;

          //one mission per line => one device id per line
          let deviceIdDataList = [];
          let count = 1 + this.pageSize * (this.currentPage - 1);
          dataList.forEach((dataItem) => {
            for (let deviceId in dataItem.deviceIdRemoteCommandDict) {
              let dataItemClone = JSON.parse(JSON.stringify(dataItem));
              dataItemClone.deviceId = deviceId;
              dataItemClone.index = count;
              deviceIdDataList.push(dataItemClone);
            }
            count++;
          });
          dataList = deviceIdDataList;

          let translatePromiseList = [];
          translatePromiseList.push(
            this.translateDataIdForDataList(
              dataList,
              'bridgeId',
              'bridgeName',
              'bridgeTranslateDict',
              this.queryBridge
            )
          );
          translatePromiseList.push(
            this.translateDataIdForDataList(
              dataList,
              'deviceId',
              'deviceName',
              'deviceTranslateDict',
              this.queryDevice
            )
          );

          dataList.forEach((dataItem) => {
            try {
              let date = newtonsoftJsonToDate(dataItem.createdDate);
              dataItem.createdDate = dateTimeToString(
                date,
                'yyyy-MM-dd HH:mm:ss'
              );
            } catch {
              //pass
            }
          });

          dataList.forEach((dataItem) => {
            if (dataItem.IsActive) {
              dataItem.status = '进行中';
              dataItem.statusType = '';
              dataItem.tooltip = '';
            } else {
              if (dataItem.IsSuccess) {
                dataItem.status = '已完成';
                dataItem.statusType = 'success';
                dataItem.tooltip = '';
              } else {
                dataItem.status = '已失败';
                dataItem.statusType = 'danger';
                dataItem.tooltip = dataItem.FailedMessage;
              }
            }
          });

          Promise.all(translatePromiseList).then(() => {
            this.tableData = dataList;
            setTimeout(() => {
              this.loading = false;
            }, 500);
          });
        });
    },
    async queryBridge(bridgeId) {
      await this.$http
        .get('/bridge/BridgeInfo?bridgeId=' + bridgeId)
        .then((res) => {
          this.bridgeTranslateDict[bridgeId] = res.data.bridgeName;
        });
    },
    async queryDevice(deviceId) {
      await this.$http
        .get('/bridge/DeviceInfo?deviceId=' + deviceId)
        .then((res) => {
          let deviceName = res.data.deviceName;
          this.deviceNameReplaceList.forEach((replaceItem) => {
            deviceName = deviceName.replace(replaceItem, '');
          });
          this.deviceTranslateDict[deviceId] = deviceName;
        });
    },
    async translateDataIdForDataList(
      refDataList,
      dataIdFieldName,
      translateResultFieldName,
      translateDictName,
      asyncQueryFunc
    ) {
      let idDict = {};
      refDataList.forEach((dataItem) => {
        if (dataItem[dataIdFieldName] !== undefined) {
          const dataKey = dataItem[dataIdFieldName];
          idDict[dataKey] = true;
        }
      });

      if (this[translateDictName] === undefined) {
        this[translateDictName] = {};
      }
      const translateDict = this[translateDictName];

      let queryPromiseList = [];
      for (let id in idDict) {
        if (translateDict[id] === undefined) {
          queryPromiseList.push(asyncQueryFunc(id));
        }
      }

      await Promise.all(queryPromiseList).then(() => {
        refDataList.forEach((dataItem) => {
          const dataKey = dataItem[dataIdFieldName];
          if (dataKey !== undefined) {
            const translateResult = translateDict[dataKey];
            dataItem[translateResultFieldName] = translateResult;
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.remote-history {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
